import { cn } from '@/lib/utils';

/**
 * Les lunettes moutarde du logo Sirajoptic. Le trait garde sa couleur sur les
 * deux fonds ; seul le nom change de teinte, le moutarde n'ayant pas assez de
 * contraste sur blanc pour du texte.
 */
export function Logo({
  ton = 'sombre',
  taille = 'md',
  className,
}: {
  /** `sombre` = posé sur le noir de la barre latérale ; `clair` = sur blanc. */
  ton?: 'sombre' | 'clair';
  taille?: 'md' | 'lg';
  className?: string;
}) {
  const grand = taille === 'lg';

  return (
    <div className={cn('flex items-center', grand ? 'gap-3' : 'gap-2.5', className)}>
      <svg viewBox="0 0 32 20" aria-hidden className={cn('shrink-0', grand ? 'h-8 w-12' : 'h-5 w-8')}>
        <circle cx="8" cy="11" r="6" fill="none" stroke="#D9A404" strokeWidth="2.5" />
        <circle cx="24" cy="11" r="6" fill="none" stroke="#D9A404" strokeWidth="2.5" />
        <path d="M14 10h4" stroke="#D9A404" strokeWidth="2.5" />
        <path d="M2 9 L0.5 5" stroke="#D9A404" strokeWidth="2" strokeLinecap="round" />
        <path d="M30 9 L31.5 5" stroke="#D9A404" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <span
        className={cn(
          'font-semibold tracking-tight',
          grand ? 'text-xl' : 'text-base',
          ton === 'sombre' ? 'text-white' : 'text-ink',
        )}
      >
        SIRAJOPTIC
      </span>
    </div>
  );
}
